import { createSmileExpressionFrames } from "../../core/expression-keyframes.js";
import { CONFETTI_VECTORS, createCelebrationFrames, createConfettiFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "celebrate",
  label: "Feiern 🥳",
  duration: 3400,
  description: "Freudensprünge, eine zweite Freude-Runde und dynamisch rieselndes Konfetti.",
  tags: ["body", "expression", "celebration", "confetti", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!scene?.confettiParticles || scene.confettiParticles.length !== CONFETTI_VECTORS.length) {
    throw new Error("Die Feier-Sequenz benötigt den vollständigen Konfetti-Layer.");
  }
  const frames = createCelebrationFrames();
  const expression = createSmileExpressionFrames({
    enterStart: .045,
    enterCross: .075,
    enterEnd: .105,
    exitStart: .90,
    exitCross: .94,
    exitEnd: .98,
    settleEnd: 1,
    smileHoldFrames: [
      { opacity: 1, transform: "scale(1.05, 1.04) translateY(0)", offset: .48 },
      { opacity: 1, transform: "scale(1.08, 1.05) translateY(0)", offset: .84 },
    ],
  });
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.openEyes, expression.openEyes, options),
    animate(elements.smileEyes, expression.smileEyes, options),
    animate(elements.mouthParty, frames.mouth, options),
    animate(elements.glow, frames.glow, options),
    ...scene.confettiParticles.map((particle, index) => animate(particle, createConfettiFrames(index), options)),
  ];
  await Promise.allSettled(animations.map(({ finished }) => finished));
}
